// src/components/Dashboard.js
import React from 'react';
import Header from './Header';
import Filters from './Filters';
import CityView from './views/CityView';
import DistrictView from './views/DistrictView';
import SchoolView from './views/SchoolView';

const Dashboard = ({ allData, filters, updateFilters, loading, error, onReload, onLoadSurveyData }) => {
  const getCurrentView = () => {
    if (filters.school && filters.school !== '') {
      return 'school';
    } else if (filters.district && filters.district !== '') {
      return 'district';
    } else {
      return 'city';
    }
  };

  const currentView = getCurrentView();

  const handleBack = () => {
    if (currentView === 'school') {
      updateFilters({ school: '' });
    } else if (currentView === 'district') {
      updateFilters({ district: '', school: '' });
    }
  };

  return (
    <div className="container">
      <Header />
      
      <Filters
        filters={filters}
        updateFilters={updateFilters}
        allData={allData}
        onReload={onReload}
        loading={loading}
      />

      {error && (
        <div className="error-notification">
          <div className="notification-content">
            <span className="notification-icon">⚠️</span>
            <div className="notification-text">
              <strong>Ошибка загрузки данных</strong>
              <div className="notification-subtext">{error}</div>
            </div>
            <button className="notification-close" onClick={() => {}}>&times;</button>
          </div>
        </div>
      )}

      <div className="views-container">
        {currentView === 'city' && (
          <CityView 
            allData={allData} 
            filters={filters} 
            updateFilters={updateFilters}
            onLoadSurveyData={onLoadSurveyData}
          />
        )}
        
        {currentView === 'district' && (
          <DistrictView
            allData={allData}
            filters={filters}
            updateFilters={updateFilters}
            onBack={handleBack}
            onLoadSurveyData={onLoadSurveyData}
          />
        )}
        
        {currentView === 'school' && (
          <SchoolView
            allData={allData}
            filters={filters}
            updateFilters={updateFilters}
            onBack={handleBack}
            onLoadSurveyData={onLoadSurveyData}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;